import dayjs from 'dayjs';

export const validatePricePlan: (values: any) => boolean = ({ price_plan_id, price_plan_revision_id }) => {
  if (!price_plan_id || !price_plan_revision_id) return false;
  return true;
};

export const validateDateRange: (values: any) => boolean = ({ start_date, end_date }) => {
  if (!start_date || !end_date) return false;

  const start = dayjs(start_date);
  const end = dayjs(end_date);

  return end.isSameOrAfter(start);
};
